import { configureDevtool } from 'mobx-react-devtools'

configureDevtool({
  logEnabled: false,
  updatesEnabled: false,
  graphEnabled: false,
  logFilter: change => change.type,
})
